<template>
  <div id="app"  class="page-container">
    <div v-if="isHome">
      <md-toolbar>
        <img src='/static/images/logo_1.png' class='header__logo-image md-image' />
      </md-toolbar>
      <router-view/>
    </div>
    <md-app v-if="!isHome">
      <md-app-toolbar>
        <img src='/static/images/logo_1.png' class='header__logo-image md-image' />
      </md-app-toolbar>
      <md-app-content>
        <router-view/>
      </md-app-content>
    </md-app>
    <footer>
      Copyright  SonicGarden 株式会社ソニックガーデン All Rights Reserved
    </footer>
  </div>
</template>

<script>
import router from '@/router'
export default {
  name: 'App',
  computed: {
    isHome () {
      return router.currentRoute.name === 'Home'
    }
  }
}
</script>

<style lang="sass">
.header__logo-image
  height: 40px
  margin: auto
footer
  text-align: center
  padding: 80px 10px
  background: #804f21
  color: #fff
</style>



// WEBPACK FOOTER //
// src/App.vue